import PropTypes from 'prop-types';
import './LandingPage.css';

export default function LandingPage({ partner, onFeedback, onIncident }) {
  return (
    <div className="lp">
      <div className="lp-hero">
        <div className="lp-plane" aria-hidden>✈</div>
        <div className="lp-logo" aria-hidden>✈️</div>
        <h1 className="lp-h1">Passenger<br />Feedback Portal</h1>
        <p className="lp-tagline">Share your experience with us</p>
      </div>

      <div className="lp-card">
        <Row icon="🏨" label="Hotel" value={partner.hotel_name || partner.name} />
      </div>

      <div className="lp-actions">
        <button type="button" className="lp-btn" onClick={onFeedback}>
          <span className="lp-btn-ico">✏️</span>
          <span className="lp-btn-label">Give Feedback</span>
          <span className="lp-btn-sub">Rate your stay</span>
        </button>
        <button type="button" className="lp-btn" onClick={onIncident}>
          <span className="lp-btn-ico">⚠️</span>
          <span className="lp-btn-label">Report Incident</span>
          <span className="lp-btn-sub">Tell us what happened</span>
        </button>
      </div>
    </div>
  );
}

function Row({ icon, label, value = '' }) {
  return (
    <div className="lp-row">
      <div className="lp-badge" aria-hidden>{icon}</div>
      <div>
        <p className="lp-lbl">{label}</p>
        <p className="lp-val">{value || '—'}</p>
      </div>
    </div>
  );
}

Row.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

LandingPage.propTypes = {
  partner: PropTypes.shape({
    name: PropTypes.string,
    hotel_name: PropTypes.string,
  }).isRequired,
  onFeedback: PropTypes.func.isRequired,
  onIncident: PropTypes.func.isRequired,
};
